/**
 * Lineup JavaScript
 *
 * This file defines behaviors of
 * the Lineup block.
 */

// for each lineup container (if we have one)
document.querySelectorAll('.lineup:not(.lineup--marquee)')?.forEach((wrap) => {
	// prep to store position info
	let pos = { minSpeed: parseInt(wrap.dataset.speed) || 10 };
	// cache some dom nodes
	const scrolls = wrap.querySelector('.lineup__frame');
	const items = scrolls.querySelectorAll('.lineup__item');
	// determine width of a single item
	const itemWidth = items[0].offsetWidth;
	// scroll to the center on initial load
	scrolls.scrollLeft = items.length * 0.5 * itemWidth;
	// set a timer to prevent infinite loop (and very jarring animation spaz-out)
	const checkFailsafe = () => {
		if (!pos.failsafe) {
			pos.failsafe = setTimeout(() => {
				clearTimeout(pos.failsafe);
				delete pos.failsafe;
			}, 100);
			return false;
		}
		console.error('Lineup has to few items: activating failsafe');
		pos.speed = 0;
		return true;
	};
	// when users scroll within the lineup
	scrolls.addEventListener('scroll', () => {
		// if scrolled all the way to the left/start
		if (scrolls.scrollLeft <= itemWidth) {
			// exit if we're in a spaz-out loop
			if (checkFailsafe()) return false;
			// scroll to the middle again
			scrolls.scrollLeft = items.length * 0.5 * itemWidth + itemWidth;
			// track our starting position (needed for dragging)
			pos = { ...pos, x: pos.trackX, left: scrolls.scrollLeft };
			// eslint-disable-next-line prettier/prettier
		// if scrolled all the way to the right/end
		} else if (
			scrolls.scrollLeft >=
			items.length * itemWidth - scrolls.clientWidth - itemWidth
		) {
			// exit if we're in a spaz-out loop
			if (checkFailsafe()) return false;
			// scroll to the middle again
			scrolls.scrollLeft =
				items.length * 0.5 * itemWidth -
				scrolls.clientWidth -
				itemWidth;
			// track our starting position (needed for dragging)
			pos = { ...pos, x: pos.trackX, left: scrolls.scrollLeft };
		}
	});
	// auto scroll
	const move = () => {
		// exit if we're not supposed to move
		if (pos.speed === 0) return false;
		// only if in view
		if (wrap.classList.contains('is-shown')) {
			// if the user isn't hovering/focusing inside the lineup and a popup isn't active
			if (
				!scrolls.matches(':hover,:focus-within') &&
				!document.body.classList.contains('popup-active')
			) {
				// scroll slowly to the right
				scrolls.scrollLeft += 1;
				// keep speed at default
				pos.speed = pos.minSpeed;
				// eslint-disable-next-line prettier/prettier
			// if the user is hovering/focused and we're not going slower than 100ms
			} else if (pos.speed < 100) {
				// continue to scroll
				scrolls.scrollLeft += 1;
				// but slow down exponentially
				pos.speed += Math.round(pos.speed ** 0.35);
			}
		}
		// call move recursively at pos.speed
		setTimeout(() => {
			move();
		}, pos.speed);
	};
	// initialize movement (if doesn't not prefer it)
	const a11y = window.matchMedia('(prefers-reduced-motion: reduce)');
	if (!a11y?.matches) {
		move();
	}

	// when the user moves their mouse inside the lineup
	scrolls.addEventListener('mousemove', (e) => {
		// if the user is clicking the mouse to drag
		if (e.buttons === 1) {
			// drag the lineup by tracking the cursor position
			scrolls.scrollLeft = pos.left + pos.x - e.pageX;
		}
		// always keep track of the cursor (needed for scroll event)
		pos.trackX = e.pageX;
	});
	// on mousedown track starting position of drag
	scrolls.addEventListener('mousedown', (e) => {
		pos = { ...pos, x: pos.trackX, left: scrolls.scrollLeft };
	});
	// disable autoplay for touch devices (prevents fighting against animation)
	scrolls.addEventListener('touchstart', () => (pos.speed = 0));
	// pass through clicks to links
	items?.forEach((item) => {
		const a = item.querySelector('a');
		if (a) {
			let clickPos = null;
			item.addEventListener('mousedown', (e) => (clickPos = e.clientX));
			item.addEventListener('mouseup', (e) => {
				if (clickPos === e.clientX) {
					a.click();
				}
			});
		}
	});
});
